import _ from 'lodash'
import useIdToFindCategory from '@/views/creative/utils/use-id-to-find-category'
import { getDefaultResource } from '../common/resource.js'

function getDiffResourceList(current, target) {
  // 比对前后两次实时预览的资源差别，提取出有变化的资源
  const diffResourceList = {}
  _.each(target, (item, key) => {
    if (!_.isEmpty(item) && !_.isEqual(current[key], item)) {
      diffResourceList[key] = item
    }
  })
  return diffResourceList
}

export default async function livePreviewResources({ state, dispatch }) {
  if (!state.canLivePreview) return

  const _resourceList = getDefaultResource(
    _.get(state, 'templateConfig.resource') || {},
    _.get(state, 'templateConfig.category') || {}
  )
  const diffResourceList = getDiffResourceList(state.currentLivePreviewResource, _resourceList)
  console.log('实时预览资源变化：', diffResourceList)

  state.currentLivePreviewResource = _resourceList
  if (_.isEmpty(diffResourceList)) {
    console.log('实时预览资源没有变化，实时预览不更新资源')
    return
  }

  _.each(diffResourceList, resource => {
    const _resource = {
      id: resource.id,
      category_id: resource.category_id
    }
    const currentCategory = useIdToFindCategory({
      category: state.templateConfig.category,
      categoryId: resource.category_id
    })

    const attrs = {}
    // 隐藏处理
    if (!_.isUndefined(_.get(currentCategory, 'properties.visible'))) {
      attrs.visible = _.get(currentCategory, 'properties.visible') === 1
    }

    // 音量处理
    let volume = _.get(currentCategory, 'properties.volume')
    if (currentCategory.file_type === 'audio' && _.isNumber(volume)) {
      // -50 时是静音，接口静音要求传参为 -100
      if (volume === -50) volume = -100
      attrs.volume = volume
    }

    dispatch('livePreview', {
      ..._resource,
      attrs
    })
  })
}
